import { motion, animate } from "motion/react";
import React, { useEffect, useRef } from "react";

export const Counter = ({ className, from, to, duration }) => {
  const nodeRef = useRef();

  useEffect(() => {
    const node = nodeRef.current;

    const controls = animate(from, to, {
      duration: duration ? duration : 1,
      onUpdate(value) {
        node.textContent = value.toFixed(0);
      },
    });

    return () => controls.stop();
  }, [from, to]);

  return (
    <p className={className ? className : "counter headline"} ref={nodeRef} />
  );
};
